//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsEleSkupinaUlozist.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Skupina �lo�i�� </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-25                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(wflsulz) GID:(Web.Dia.Ts) V1:(ixs_ulz,nazev,poznamka,aktivita,dat_zmena,zmenu_prov,priz_pub,priz_ud,priz_vycet) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // EleSkupinaUlozist
    export function DetailEleSkupinaUlozistDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ulz */
            ixs_ulz: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailEleSkupinaUlozist', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmEleSkupinaUlozist#",
        ixs_ulz: opt ? opt.ixs_ulz : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // EleSkupinaUlozist
    export function SeznamEleSkupinaUlozistDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ulz */
            ixs_ulz: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamEleSkupinaUlozist', { }]

    const options = {
        ID: "AdmEleSkupinaUlozist#",
        ixs_ulz: opt ? opt.ixs_ulz : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
